//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "DialogAuth",
  data() {
    return {
      curRole: "",
    };
  },
  props: {
    dialogAuthVisible: {
      type: Boolean,
      default: () => true,
    },
    curAccount: {
      type: Object,
      default: () => {},
    },
    defaultProps: {
      type: Object,
      default: () => {},
    },
    ownAuthData: {
      type: Array,
      default: () => [],
    },
    type: {
      type: Number,
      default: () => 0,
    },
  },
  components: {},
  computed: {},
  methods: {
    /**
     * @description: 关闭弹窗
     * @Author: yangsibo
     * @Date: 2022-05-25 09:32:01
     */
    close() {
      this.$emit("close", "dialogAuthVisible");
    },
    showAccount() {
      this.$emit("showAccount");
    },
    handleChangeRole(data) {
      if (this.curRole == data) {
        this.curRole = data == 0 ? -0.1 : -data;
      } else {
        this.curRole = data;
      }
    },
  },
  created() {},
  mounted() {},
};
